// Low level enums

// appli en cours
export enum APP_ORIGIN {
  AKM = 'AKM',
  DOM = 'DOM',
  CONNECT = 'CONNECT', 
  COMPUTE = 'COMPUTE'
}

// valeurs exotiques
export enum EXO_VALUE {
  FAKE = 'FAKE', // marque d'un objet Fake
  SELECT_ALL = 'SELECT_ALL', // check tous / aucun
  VOID = 'VOID',
}

// Intercepted keycodes on applicative lock
export enum LOCKED_KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
  TAB = 9,
  ENTER = 13,
  SPACE = 32,
}

// HTTP methods
export enum WIZ_COMMAND_HTTP_METHOD {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  PATCH = 'patch',
  DELETE = 'delete',
}

// Command state contants
export enum WIZ_COMMAND_STATE {
  INIT = 'INIT', // pas lancée
  PENDING = 'PENDING', // en cours
  SUCCESS = 'SUCCESS', // retour OK
  FAULT = 'FAULT', // retour KO
}

// méthode des commande
export enum WIZ_COMMAND_METHOD {
  FIND = 'find',
  GET = 'get',
  CREATE = 'create',
  CREATE_LIST = 'createList',
  UPDATE = 'update',
  UPDATE_LIST = 'updateList',
  DELETE = 'delete',
  DELETE_LIST = "deleteList",
  COUNT = 'count'
}

// HTTP return types
export enum WIZ_COMMAND_RESPONSE_TYPE {
  JSON = 'JSON',
  TEXT = 'TEXT',
  ARRAY_BUFFER = 'ARRAY_BUFFER',
  BLOB = 'BLOB',
}

// Position constants
export enum WIZ_PHYSIC_POSITION {
  TOP_LEFT = 0,
  TOP_RIGHT = 1,
  BOTTOM_LEFT = 2,
  BOTTOM_RIGHT = 3,
  MIDDLE_CENTER = 4,
}

// unités de mesure
export enum WIZ_UNITS {
  PIXEL = 'px',
  PERCENT = '%',
  EURO = '€',
}

// constantes des numériques, à chercher dans le fichier de trad
export enum WIZ_NUMERIC_CONSTANT {
  DECIMAL_SEPARATOR = 'numeric.decimal.separator',
  THOUSAND_SEPARATOR = 'numeric.thousand.separator',
  NB_DECIMAL = 'numeric.nb.decimal',
}

/** valeurs disponibles pour alimentation des bolean / trilean */
export enum WIZ_BOOLEAN {
  TRUE = '1',
  FALSE = '0',
  UNKNOWN = 'undefined',
}

/** positions latérales gauche / droite (utilisé par la checkbox) */
export enum WIZ_LATERAL {
  BEFORE = 'before',
  AFTER = 'after',
}

// Edition mode
export enum WIZ_EDITION_MODE {
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  READ_ONLY = 'READ_ONLY',
}

// Navigation button types
export enum NAVIGATION_FUNCTION_KIND {
  BUTTON = 'BUTTON',
  SPACER = 'SPACER',
  SEARCH = 'CUSTOM',
}

// types de comportements sur perte de focus pour composant en erreur
export enum FOCUS_MODE {
  STOP = 'STOP', // prevent. Pas de perte de focus autorisée
  ROLLBACK = 'ROLLBACK', // retour à la dernière bonne conf et sortie (BaseComponent.lastGoodValue)
  PASS = 'PASS', // compo en erreur, mais sortie autorisée
  NONE = 'NONE', // pas de traitement d'erreur
}

// WIZ event types (TODO: To complete)
export enum WIZ_EVENT_TYPE {
  CHANGING = 'WIZ_CHANGING', // The value of an edition component is changing
  CHANGE = 'WIZ_CHANGE', // The value of an edition component has changed
  MODEL_UPDATE = 'MODEL_UPDATE', // Evénement WIZ_CHANGE sur un composant METIER. Dispatché en plus du change
  FOCUS_IN = 'WIZ_FOCUS_IN', // A focusable component gets the focus
  FOCUS_OUT = 'WIZ_FOCUS_OUT', // A focusable component lose the focus
  CLICK = 'WIZ_CLICK', // A component has been clicked
  DOUBLE_CLICK = 'WIZ_DOUBLE_CLICK', // A component has been double-clicked
  TRANSLATION_LOADED = 'WIZ_TRANSLATION_LOADED', // End of translation loading and refresh
  NAVIGATE_START = 'WIZ_NAVIGATE_START', // ask for navigate, From view is OK
  NAVIGATE_END = 'WIZ_NAVIGATE_END', // navigation terminée, la demande de navigation a passé les gardes la prochaine vue est validée
  NAVIGATE_UNREGISTER = 'WIZ_NAVIGATE_UNREGISTER', // unregister old view BEFORE navigation
  NAVIGATE_SET_VIEW = 'WIZ_NAVIGATE_SET_VIEW', // sur constructeur, signaler la prochaine vue
  NAVIGATE_REGISTER = 'WIZ_NAVIGATE_REGISTER', // register new view AFTER navigation but BEFORE complete build
  NODE_SELECTED = 'WIZ_NODE_SELECTED', // wiz-tree event of node with checkbox
  DELETE = 'WIZ_DELETE', // element has been deleted
  CLEAR = 'WIZ_CLEAR', // suppression de la valeur d'un champ (croix)
  ADD = 'WIZ_ADD', // an element has been added to any collection or map or hierarchy
  DRAGGER_DOUBLE_CLICK = 'DRAGGER_DOUBLE_CLICK', // 2xClic sur le dragger d'un DividedGroup
  DRAG_STARTED = 'DRAG_STARTED', // an item  has been dragged
  DRAG_DROPPED = 'DRAG_DROPPED', // an dragged item has been released
  DRAG_MOVING = 'DRAG_MOVING', // an item is been drag
  DRAG_MOVED = 'DRAG_MOVING', // an item has been move (drag'n'drop same target)
  DROP_ENTERED = 'DROP_ENTERED', // an drop container has been entered
  DROP_LEAVED = 'DROP_LEAVED', // an drop container has been leaved
  DROP_LOST_ITEM = 'DROP_LOST_ITEM', // on vient de perdre un item sur dragMove vers l'extérieur
  INIT_COMPLETE = 'INIT_COMPLETE', // the initialization is complete
  SELECTION_CHANGING = 'SELECTION_CHANGING', // indicates that the selection for a component is changing
  SELECTION_CHANGED = 'SELECTION_CHANGED', // indicates that the selection for a component has changed,
  INPUT_LEFT_CLICK = 'INPUT_LEFT_CLICK', // appel de la fonction gauche d'un TextInput
  INPUT_RIGHT_CLICK = 'INPUT_RIGHT_CLICK', // appel de la fonction droite d'un TextInput
  TAB_OTHER = 'TAB_OTHER', // Clic bouton 'autre' de la tab bar
  GLOBAL_ENTER_KEY = 'GLOBAL_ENTER_KEY', // ctrl + entrée
  GLOBAL_ENTER_ADD_KEY = 'GLOBAL_ENTER_ADD_KEY', // ctrl + shift + entrée pour save + add
  GLOBAL_BACK_KEY = 'GLOBAL_BACK_KEY', // ctrl + backspace
  GLOBAL_LIST_KEY = 'GLOBAL_LIST_KEY', // ctrl + début pour retour de focus dans la liste
  FILTER = 'FILTER', // un compo filtre est modifié
  GRID_EDIT_END = 'GRID_EDIT_END', // fin d'édition d'une cellule du grid
  GRID_EDIT_START = 'GRID_EDIT_START', // début d'édition d'une cellule du grid
  GRID_ROW_CLICKED = 'GRID_ROW_CLICKED', // Indique qu'une ligne a été cliquée dans le grid
  VIEW_UP = 'VIEW_UP', // après WizSynchronizeData, cet évenement signale aux composants que tout est chargé
  CMD_ERR = 'CMD_ERR', // erreur de service dans WizCommand
  ROW_GROUP_CHANGED = 'ROW_GROUP_CHANGED', // modification du expand pour les groupes de rows dans le grid
  ROW_GROUP_EXPAND = 'ROW_GROUP_EXPAND', // expand / close sur header de rowGroup
  LOCALE_CHANGED = 'LOCALE_CHANGED' // changement de locale
  
}

// Default error message keys
export enum WIZ_ERROR_MESSAGE {
  MAX_LENGTH = 'validators.stringValidator.tooLongError', // String max length validation error
  MIN_LENGTH = 'validators.stringValidator.tooShortError', // String min length validation error
  REQUIRED = 'validators.stringValidator.requiredFieldError', // Mandatory validation error
  EMAIL = 'validators.emailValidator.invalidCharError', // Email validation error
  PATTERN = 'validators.regExpValidatorValidator.noMatchError', // regexp/pattern validation error
  MAX_NUMBER = 'validators.numberValidator.greaterThanMaxError', // Number max validation error
  MIN_NUMBER = 'validators.numberValidator.lowerThanMinError', // Number min validation error
  INVALID_DATE = 'validators.dateValidator.invalidDate', // date validation validation error
  INVALID_HOUR = 'validators.dateValidator.invalidHour', // hour validation error
}

/**
 * Boutons disponibles pour la pop de confirmation
 */
export enum CONFIRMATION_MODE {
  CONFIRM_CANCEL = 'CONFIRM_CANCEL',
  YES_NO = 'YES_NO',
  OK = 'OK',
}

/**
 * Constante de retour de la confirmation popup
 */
export enum CONFIRMATION_RESULT {
  CONFIRM = 'CONFIRM',
  CANCEL = 'CANCEL',
  YES = 'YES',
  NO = 'NO',
  OK = 'OK',
}

/**
 * Constantes d'erreur de l'upload de fichier
 */
export enum WIZ_UPLOAD_ERROR {
  UPLOAD_ERROR_MAX_SIZE = '$.file.error.maxsize.$', // fichier trop volumineux
  UPLOAD_ERROR_FILE_EXTENSION = '$.file.error.extension.$', // extension non acceptées
}

export enum WIZ_UPLOAD_ACCEPT_FORMAT { // TODO ALA commentaires !
  IMAGE_JPEG = '.jpg,.jpeg',
  IMAGE_PNG = '.png',
  IMAGE_SVG = '.svg',
  IMAGE_WEBP = '.webp',
  IMAGE_AVIF = '.avif',
  IMAGE_GIF = '.gif',
  FILE_CSV = '.csv',
  FILE_TXT = '.txt',
  FILE_JSON = '.json',
  FILE_ZIP = '.zip,.7z',
  FILE_XLS = '.xls,.xlsx',
  FILE_DOC = '.doc,.docx',
  FILE_PDF = '.pdf',
  FILE_ANY = '.*',
}

// types d'objets filtre
export enum FILTER_TYPE {
  BOOLEAN = 'BOOLEAN', // booléen, seul false est pris en compte (si coché, affiche aussi les "false")
  TRUELEAN = 'TRUELEAN', // booléen, seul true est pris en compte (si coché, n'affiche que les "true")
  TRILEAN = 'TRILEAN', // 3 states, true et false pris en compte
  LIST_MONO = 'LIST_MONO', // choix d'un élément dans une liste
  LIST_MULTI = 'LIST_MULTI', // liste choix multiples
  TEXT = 'TEXT', // texte libre
  INT = 'INT', // entier
  NUMBER = 'NUMBER', // décimal
  DATE = 'DATE', // une date
  TIME = 'TIME', // une heure
  TOGGLE = 'TOGGLE', // l'un des deux choix
}
